import { ProjectDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Grid, GridSpacing } from '@mui/material';
import * as _ from 'lodash';

interface ProjectAddressProps {
  address: ProjectDto['address'];
  options?: {
    spacing?: GridSpacing;
  };
}

export function ProjectAddress({ address, options }: ProjectAddressProps) {
  if (!address) {
    return null;
  }

  const { line1, line2, suburb, state, postcode } = address;
  const { spacing = 0 } = options || {};

  const hasAddressLine1 = !_.isEmpty(line1);
  const hasAddressLine2 = !_.isEmpty(line2);
  const hasAddressLine3 = !_.isEmpty(suburb) || !_.isEmpty(state) || !_.isEmpty(postcode);

  const addressLine1 = hasAddressLine1 ? `${line1 + (hasAddressLine2 || hasAddressLine3 ? ', ' : '')}` : undefined;
  const addressLine2 = hasAddressLine2 ? `${line2 + (hasAddressLine3 ? ',' : '')}` : undefined;
  const addressLine3 = `${suburb ? suburb + ' ' : ''}${state ? state + ' ' : ''}${postcode || ''}`;

  return (
    <Grid container sx={{ flexDirection: 'column' }} spacing={spacing}>
      {addressLine1 ? <Grid>{addressLine1}</Grid> : null}
      {addressLine2 ? <Grid>{addressLine2}</Grid> : null}
      {addressLine3 ? <Grid>{addressLine3}</Grid> : null}
    </Grid>
  );
}
